import { GetRaceName, GetRaceColor } from '@/core/game/WoWRaces';
import { GetClassName, GetClassColor } from '@/core/game/WoWClasses';
import { Role } from '@/core/security/Role';
import GameService from '@/services/game/game.service';
import { WoWRace, WoWClass, WoWGender, GameRole } from '@/types/apiServerContract';

export class HelperMethods {
    static GetRoleColor(role: Role): string {
        switch (role) {
        case Role.SuperAdmin:
            return 'Purple';
        case Role.Administrator:
            return 'Red';
        case Role.Developer:
            return 'Orange';
        default:
            throw new Error(`Unknown role: ${role}`);
        }
    }

    static GetGameRankName(rank: GameRole, short: boolean = false) {
        switch (rank) {
        case GameRole.Admin:
            return short ? 'Admin' : 'Administrator';
        case GameRole.GameMaster:
            return short ? 'GM' : 'GameMaster';
        case GameRole.Trial:
            return short ? 'Trial' : 'Trial GameMaster';
        case GameRole.Player:
            return short ? 'Player' : 'Player';
        }
    }

    static GetGameRankColor(rank: GameRole) {
        switch (rank) {
        case GameRole.Admin:
            return 'Red';
        case GameRole.GameMaster:
            return 'Blue';
        case GameRole.Trial:
            return 'Teal';
        case GameRole.Player:
            return 'Green';
        }
    }

    static GetRaceName(raceId: WoWRace): string {
        return GetRaceName(raceId);
    }

    static GetRaceColor(raceId: WoWRace): string {
        return GetRaceColor(raceId);
    }

    static GetClassColor(classId: WoWClass): string {
        return GetClassColor(classId);
    }

    static GetClassName(classId: WoWClass): string {
        return GetClassName(classId);
    }

    static GetGender(genderId: WoWGender): string {
        switch (genderId) {
        case 0:
            return 'Male';
        case 1:
            return 'Female';
        default: throw new Error('unknown gender' + genderId);
        }
    }

    static IsAlliance(race: WoWRace): boolean {
        switch (race) {
        case WoWRace.RACE_HUMAN:
        case WoWRace.RACE_DWARF:
        case WoWRace.RACE_GNOME:
        case WoWRace.RACE_NIGHT_ELF:
        case WoWRace.RACE_DRAENEI:
        case WoWRace.RACE_WORGEN:
            return true;
        }

        return false;
    }

    static IsHorde(race: WoWRace): boolean {
        switch (race) {
        case WoWRace.RACE_BLOOD_ELF:
        case WoWRace.RACE_ORC:
        case WoWRace.RACE_TAUREN:
        case WoWRace.RACE_TROLL:
        case WoWRace.RACE_UNDEAD:
        case WoWRace.RACE_GOBLIN:
            return true;
        }

        return false;
    }

    static async GetZone(ZoneId: number): Promise<string> {
        return GameService.zoneSerice.getZoneName(ZoneId);
    }

    static async GetMap(MapId: number): Promise<string> {
        return GameService.mapService.getMapName(MapId);
    }
}
